import LanguageSwitcher from "../LanguageSwitcher";
import styles from "./styles.module.css";
import MenuItem from "@components/atoms/MenuItem";
import config from "config/all-config.json";
import { useLocale, useTranslations } from "next-intl";
import { usePathname } from "next-intl/client";
import Link from "next-intl/link";
import Image from "next/image";
import { useState } from "react";
import { NavProps } from "types/Nav.type";

export default function NavMobile({ expandMenu, setExpandMenu }: NavProps) {
  const t = useTranslations("menu");
  const [selectedNavbarItem, setSelectedNavbarItem] = useState("home");
  const pathname = usePathname();
  const locale = useLocale();

  const selectItem = (item: string) => {
    if (selectedNavbarItem === item) {
      setSelectedNavbarItem("");
    } else {
      setSelectedNavbarItem(item);
    }
  };

  const closeMobileMenu = () => {
    setExpandMenu(false);
  };

  return (
    <nav id="nav" className={`${styles.nav} ${expandMenu ? "z-[100]" : "-z-10 h-0"}`}>
      <div
        className={`${styles.mobileNav} ${
          expandMenu ? styles.mobileNavDisplay : ""
        }`}
      >
        <div
          style={{
            width: "100%",
            minHeight: "100%",
            padding: "30px",
            overflow: "scroll",
          }}
        >
          {expandMenu && (
            <>
              <div className={styles["links-container"]}>
                <Image
                  src="/logo-labs-white.webp"
                  title="Logo"
                  alt="logo"
                  priority={true}
                  width={144}
                  height={30}
                />

                <div
                  onClick={() => setExpandMenu(false)}
                  className="text-white text-[38px]"
                >
                  x
                </div>
              </div>

              <div>
                {config.menu.map((item, key) => {
                  let isActive = false;
                  if (t(`${key}.href`) === "/" && pathname === "/")
                    isActive = true;
                  else
                    isActive =
                      pathname.includes(t(`${key}.href`)) &&
                      t(`${key}.href`) !== "/";
                  return (
                    <div key={t(`${key}.title`)}>
                      {!item.submenu && (
                        <div>
                          <MenuItem
                            key={t(`${key}.title`)}
                            title={t(`${key}.title`)}
                            href={t(`${key}.href`)}
                            isActive={isActive}
                            setExpandMenu={setExpandMenu}
                            style={styles.navbarMenuItem}
                          />
                        </div>
                      )}
                      {item.submenu && (
                        <div className={styles.dropdownMobile}>
                          <div
                            onClick={() => {
                              selectItem(t(`${key}.title`).toLowerCase());
                            }}
                          >
                            <div
                              className={
                                isActive
                                  ? styles.selectedNavbarItem
                                  : styles.navbarItem
                              }
                            >
                              <MenuItem
                                key={t(`${key}.title`)}
                                title={t(`${key}.title`)}
                                href={t(`${key}.href`)}
                                isActive={isActive}
                                setExpandMenu={setExpandMenu}
                              />
                              <div className="mb-2">
                                <svg
                                  width="8"
                                  height="5"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M3.31833 4.57545L0.0841112 1.18105C0.0301194 1.12441 0 1.04916 0 0.970914C0 0.892665 0.0301194 0.817419 0.0841112 0.760782L0.0877657 0.757127C0.11394 0.729575 0.145445 0.707637 0.180366 0.692645C0.215286 0.677653 0.252891 0.669922 0.290894 0.669922C0.328896 0.669922 0.366502 0.677653 0.401422 0.692645C0.436343 0.707637 0.467848 0.729575 0.494022 0.757127L3.53942 3.95358L6.58361 0.757127C6.60978 0.729575 6.64129 0.707637 6.67621 0.692645C6.71113 0.677653 6.74873 0.669922 6.78674 0.669922C6.82474 0.669922 6.86234 0.677653 6.89726 0.692645C6.93219 0.707637 6.96369 0.729575 6.98987 0.757127L6.99352 0.760782C7.04751 0.817419 7.07763 0.892665 7.07763 0.970914C7.07763 1.04916 7.04751 1.12441 6.99352 1.18105L3.7593 4.57545C3.73086 4.60531 3.69665 4.62907 3.65875 4.64531C3.62085 4.66155 3.58005 4.66992 3.53882 4.66992C3.49758 4.66992 3.45678 4.66155 3.41888 4.64531C3.38098 4.62907 3.34677 4.60531 3.31833 4.57545Z"
                                    fill="white"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className={styles.dropdownContentMobile}
                            style={{
                              display: "inline-flex",
                            }}
                          >
                            {item.submenu.map((listItem, index) => {
                              return (
                                <Link
                                  locale={locale}
                                  href={t(`${key}.submenu.${index}.href`)}
                                  title="Navbar item"
                                  key={index}
                                  onClick={() => {
                                    selectItem(
                                      t(
                                        `${key}.submenu.${index}.href`
                                      ).toLowerCase()
                                    );
                                    closeMobileMenu();
                                  }}
                                  className={
                                    pathname ===
                                    t(
                                      `${key}.submenu.${index}.href`
                                    ).toLowerCase()
                                      ? `${styles.selectedNavbarItem} mt-0`
                                      : undefined
                                  }
                                >
                                  {t(`${key}.submenu.${index}.title`)}
                                </Link>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
                <div className='w-[155px] ml-4 my-6'>
                  <a href="tel:+40765968506" className='flex items-center w-full py-2'>
                    <Image src='/call.svg' alt='Phone number' width={16} height={16} className='mr-2' />
                    <span>+40 765 968 506</span>
                  </a>
                  <a href="tel:+40751088733" className='flex items-center w-full py-2'>
                    <Image src='/call.svg' alt='Phone number' width={16} height={16} className='mr-2' />
                    <span>+40 751 088 733</span>
                  </a>
                </div>
                <LanguageSwitcher isMobile={true} />
              </div>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
